import styled from "styled-components";

export const RailOuter = styled.div`
  position: absolute;
  left: -12px;
  width: calc(100% + ${({ theme }) => theme.filters.height.lg});
  height: ${({ theme }) => `calc(${theme.filters.height.default} * 2)`};
  transform: translate(0%, -50%);
  border-radius: 7px;
  cursor: ${({ $disabled }) => ($disabled ? "default" : "pointer")};
`;

export const RailInner = styled.div`
  position: absolute;
  left: -12px;
  width: calc(100% + ${({ theme }) => theme.filters.height.lg});
  height: ${({ theme }) => theme.filters.height.lg};
  transform: translate(0%, -50%);
  border-radius: 11px;
  pointer-events: none;
  background-color: ${({ theme }) => theme.backgroundTag};
`;
